import type { GlobalDataSourceId } from '#layers/data-model/public';
import { defineEntitlement, defineResourceEntitlement } from '#layers/access/utils/entitlements';

// Data model
export const canEditDataModel = defineEntitlement('dataModel', 'edit');
export const canReadDataModel = defineEntitlement('dataModel', 'read');
export const canReadExtensions = defineEntitlement('extension', 'read');

// Workspace members
export const canAddWorkspaceMember = defineEntitlement('workspaceMembers', 'add');
export const canDeleteWorkspaceMember = defineEntitlement('workspaceMembers', 'delete');

// Data sources
export const canCreateDataSource = defineEntitlement('dataSource', 'create');
export const canReadDataSource = defineResourceEntitlement<GlobalDataSourceId>('dataSource', 'read');
export const canDeleteDataSource = defineResourceEntitlement<GlobalDataSourceId>('dataSource', 'delete');

// Roles
export const canCreateRole = defineEntitlement('role', 'create');
export const canAssignRole = defineResourceEntitlement('role', 'assign');
export const canUpdateRole = defineResourceEntitlement('role', 'update');
export const canDeleteRole = defineResourceEntitlement('role', 'delete');

// Policies
export const canCreatePolicy = defineEntitlement('policy', 'create');
export const canAssignPolicy = defineResourceEntitlement('policy', 'assign');
export const canUpdatePolicy = defineResourceEntitlement('policy', 'update');
export const canDeletePolicy = defineResourceEntitlement('policy', 'delete');

// Key storage
export const canAccessOwnKeyStorage = defineEntitlement('keyStorage', 'accessOwn');
export const canAccessSharedKeyStorage = defineEntitlement('keyStorage', 'accessShared');

// AI
export const canAdminAi = defineEntitlement('ai', 'admin');

// OpenAPI schema
export const canReadOpenApiSchema = defineEntitlement('openApiSchema', 'read');

// Workspace settings
export const canEditWorkspaceSettings = defineEntitlement('workspaceSettings', 'edit');

// Spaces
export const canReadSpace = defineResourceEntitlement('space', 'read');

/**
 * Every workspace `can*` constant. The descriptor-sync test asserts each one is a real
 * Engine entitlement with matching scope, so a new constant must be added here.
 */
export const WORKSPACE_ENTITLEMENTS = [
	canEditDataModel,
	canReadDataModel,
	canReadExtensions,
	canAddWorkspaceMember,
	canDeleteWorkspaceMember,
	canCreateDataSource,
	canReadDataSource,
	canDeleteDataSource,
	canCreateRole,
	canAssignRole,
	canUpdateRole,
	canDeleteRole,
	canCreatePolicy,
	canAssignPolicy,
	canUpdatePolicy,
	canDeletePolicy,
	canAccessOwnKeyStorage,
	canAccessSharedKeyStorage,
	canAdminAi,
	canReadOpenApiSchema,
	canEditWorkspaceSettings,
	canReadSpace,
];
